export default "/images/vendor/flag-icon-css/flags/1x1/lu.svg?1de57f2a9396a1bb33258b968c09dc34";